import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * provider.tsx
 *
 * Forked from reactabular-table version 8.14.0
 * https://github.com/reactabular/reactabular/tree/v8.14.0/packages/reactabular-table/src
 */


import * as React from 'react';
import { TableDefaults } from './types';
export var ProviderContext = React.createContext({
  columns: null,
  renderers: null
});
export var Provider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Provider, _React$Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          renderers = _this$props.renderers,
          components = _this$props.components,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["columns", "renderers", "components", "children"]);

      var finalRenderers = renderers;

      if (components) {
        // tslint:disable-next-line:no-console
        console.warn('`components` have been deprecated in favor of `renderers` and will be removed in the next major version, please rename!');
        finalRenderers = components;
      }

      var provider = React.createElement(renderers.table || TableDefaults.renderers.table, props, children);
      return React.createElement(ProviderContext.Provider, {
        value: {
          columns: columns,
          renderers: {
            table: finalRenderers.table || TableDefaults.renderers.table,
            header: _objectSpread({}, TableDefaults.renderers.header, finalRenderers.header),
            body: _objectSpread({}, TableDefaults.renderers.body, finalRenderers.body)
          }
        }
      }, provider);
    }
  }]);

  return Provider;
}(React.Component);

_defineProperty(Provider, "propTypes", {
  children: _pt.node,
  role: _pt.string,
  className: _pt.string
});

_defineProperty(Provider, "defaultProps", {
  renderers: TableDefaults.renderers
});